import React from 'react'

const Completed = () => {
  return (
    <div className="completed">Completed</div>
  )
}

export default Completed